// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Lock from "@insite/mobius/Icons/Lock";
import { wishListSharingStatusStyles } from "@sc/Overrides/Components/WishListSharingStatus";
import { TRANSLATE_OBJECT } from "@sc/XDL/constants";
import { css } from "styled-components";

wishListSharingStatusStyles.privateShareTooltip = {
    cssOverrides: {
        tooltipWrapper: css``,
        tooltipClickable: css`
            margin-left: 8px;
            margin-right: 0;
        `,
    },
    iconProps: {
        size: 13,
        color: "info.main",
        css: css`
            margin-left: 3px;
            &,
            svg {
                width: 12px;
            }
        `,
    },
};

wishListSharingStatusStyles.statusText = {
    size: 12,
    lineHeight: "14px",
    css: css`
        display: flex;
        align-items: center;
        & {
            padding-left: 0px;
        }
    `,
    ...(TRANSLATE_OBJECT as any),
};

wishListSharingStatusStyles.privateTooltip = {
    iconProps: {
        size: 13,
        color: "info.main",
        css: css`
            &,
            svg {
                width: 12px;
            }
        `,
    },
};

wishListSharingStatusStyles.autogeneratedIcon = {
    src: Lock,
    color: "common.ui9",
    css: css`
        width: 11px;
        height: 13px;
        margin-right: 8px;
    `,
};
